import { useCurrentUser } from '@capturi/core'
import { useFeatureFlags } from '@capturi/feature-flags'
import { t } from '@lingui/macro'

type UseQANavigationGroup = {
  show: boolean
  disabled: boolean
  tooltip?: string
}
export const useQANavigationGroup = (): UseQANavigationGroup => {
  const { enableQualityAssurance, enableScoring } = useFeatureFlags()
  const { permissions } = useCurrentUser()
  const upgradeTooltip = t`Upgrade to get access to full quality assurance`

  // Base
  if (!enableQualityAssurance && !enableScoring) {
    return {
      show: true,
      disabled: true,
      tooltip: upgradeTooltip,
    }
  }

  // Current customers
  if (enableScoring && !enableQualityAssurance) {
    if (permissions.editScore) {
      return {
        show: true,
        disabled: false,
        tooltip: upgradeTooltip,
      }
    }
    return {
      show: true,
      disabled: true,
      tooltip: upgradeTooltip,
    }
  }

  // Plus QA
  if (enableQualityAssurance) {
    const { editQuestionnaire, editScore, qualityAssurance } = permissions
    if (!editQuestionnaire && !editScore && !qualityAssurance) {
      return {
        show: false,
        disabled: true,
        tooltip: undefined,
      }
    }

    return {
      show: true,
      disabled: false,
      tooltip: undefined,
    }
  }

  return {
    show: true,
    disabled: false,
    tooltip: undefined,
  }
}
